import styled from "@emotion/styled";
import * as React from "react";
import { Power } from "react-feather";
import { useNavigate } from "react-router-dom";
import { Chip, Grid, Menu, MenuItem, IconButton as MuiIconButton, Tooltip, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../../hooks/useAuth";
import { fetchCurrentBalanceByClientId } from "../../redux/userManagement/userManagementThunk";
import { ERoles, formatNumberWithComma } from "../../config";

const IconButton = styled(MuiIconButton)`
    svg {
        width: 22px;
        height: 22px;
    }
`;

let intervalID = null;
export const NavbarBillingDetails = () => {
    const state = useSelector(state => state.userManagementSlice);
    const dispatch = useDispatch();



    const { user } = useAuth();


    React.useEffect(() => { }, [state.userCurrentBalance]);

    React.useEffect(() => {
        // fetchCurrentBalanceByClientId();
        if (user && (user?.roleName.toLowerCase() === ERoles.ORG_ADMIN || user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN)) {
            dispatch(fetchCurrentBalanceByClientId());
        }
    }, []);

    if (!intervalID) {
        if (user && (user?.roleName.toLowerCase() === ERoles.ORG_ADMIN || user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN)) {
            intervalID = setInterval(() => {
                if (user && (user?.roleName.toLowerCase() === ERoles.ORG_ADMIN || user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN)) {
                    dispatch(fetchCurrentBalanceByClientId());
                }
            }, 60000);
        }
    }

    return (
        <React.Fragment>

            <Grid display={"flex"}>
                {state?.userBillingType === "Postpaid" ? (
                    <Grid display={"flex"} flexDirection={"column"}>
                        <Typography sx={{ color: "green", fontWeight: "bold" }}>Billing Type : Postpaid</Typography>

                        <Typography sx={{ color: "green", fontWeight: "bold" }}>
                            Amount Used : Rs.{" "}
                            {typeof state.userCurrentBalance !== "string" ? state?.userCurrentBalance?.toFixed(2) : state?.userCurrentBalance}
                            /-
                        </Typography>

                        {state?.postpaidUserCapcheck && (
                            <Typography sx={{ color: "green", fontWeight: "bold" }}>
                                Max balance limit : Rs. {state?.postpaidUserMaxLimit?.toFixed(2)}/-
                            </Typography>
                        )}
                    </Grid>
                ) : (
                    <div>
                        <Typography sx={{ color: "green", fontWeight: "bold" }}>Billing Type : Prepaid &nbsp;</Typography>
                        <Typography sx={{ color: "green", fontWeight: "bold" }}>
                            Amount Used : Rs. {formatNumberWithComma(state.userUsage?.toFixed(2))}
                            /-
                        </Typography>
                        <Typography style={{ color: "green", fontWeight: "bold" }}>
                            Balance : Rs.{" "}
                            {typeof state?.userCurrentBalance !== "string"
                                ? formatNumberWithComma(state?.userCurrentBalance?.toFixed(2))
                                : formatNumberWithComma(state?.userCurrentBalance)}
                            /-
                        </Typography>
                    </div>
                )}
                {/* 
                {user?.orgDetails?.supportedProviders.map((provider) => (
                    <Chip size="small" label={provider.providerCode.split("_")[0]} sx={{ margin: "4px" }} />
                ))}

                {user?.resellerDetails?.supportedProviders.map((provider) => (
                    <Chip size="small" label={provider.providerCode.split("_")[0]} sx={{ margin: "4px" }} />
                ))} */}
                {/* <Typography style={{ fontWeight: "bold" }}> */}
                {/* { } */}
                {/* </Typography> */}
                {/* </Chip> */}
            </Grid>

        </React.Fragment >
    );
}

